module.exports = __webpack_public_path__ + "img/home.d559e154.svg";